import React from 'react';
import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemType } from '@src/framework/workbench/drawer/constants';
import {
    TABLE_BOXICON_1_ICON,
    TABLE_BOXICON_3_ICON,
    TABLE_BOXICON_4_ICON,
    TABLE_BOXICON_5_ICON,
    TABLE_BOXICON_6_ICON,
    TABLE_BOXICON_7_ICON,
    TABLE_BOXICON_8_ICON,
    TABLE_BOXICON_9_ICON,
    TABLE_BOXICON_10_ICON,
} from '@framework/workbench/drawer/image';
import { TOOLBAR_BOX_2 } from '@src/framework/editor/src/img/pageIndex';
import { config } from '@framework/workbench/ui/border-style/config';

export const FORM_CONFIGS_TABLE_BORDER: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: config.dropdown.data[0].id,
        options: {
            icon: <img src={TABLE_BOXICON_1_ICON} alt={''} style={{ margin: '-4px' }}/>,
        },
        tooltip: config.dropdown.data[0].tipMsg,
    },
    {
        type: FormItemType.BUTTON,
        name: config.dropdown.data[1].id,
        options: {
            icon: <img src={TOOLBAR_BOX_2} alt={''} style={{ width: '24px', height: '24px', margin: '-4px' }}/>,
        },
        tooltip: config.dropdown.data[1].tipMsg,
    },
    {
        type: FormItemType.BUTTON,
        name: config.dropdown.data[2].id,
        options: {
            icon: <img src={TABLE_BOXICON_3_ICON} alt={''} style={{ margin: '-4px' }}/>,
        },
        tooltip: config.dropdown.data[2].tipMsg,
    },
    {
        type: FormItemType.BUTTON,
        name: config.dropdown.data[3].id,
        options: {
            icon: <img src={TABLE_BOXICON_4_ICON} alt={''} style={{ margin: '-4px' }}/>,
        },
        tooltip: config.dropdown.data[3].tipMsg,
    },
    {
        type: FormItemType.BUTTON,
        name: config.dropdown.data[4].id,
        options: {
            icon: <img src={TABLE_BOXICON_5_ICON} alt={''} style={{ margin: '-4px' }}/>,
        },
        tooltip: config.dropdown.data[4].tipMsg,
    },
    {
        type: FormItemType.BUTTON,
        name: config.dropdown.data[5].id,
        options: {
            icon: <img src={TABLE_BOXICON_6_ICON} alt={''} style={{ margin: '-4px' }}/>,
        },
        tooltip: config.dropdown.data[5].tipMsg,
    },
    {
        type: FormItemType.BUTTON,
        name: config.dropdown.data[6].id,
        options: {
            icon: <img src={TABLE_BOXICON_7_ICON} alt={''} style={{ margin: '-4px' }}/>,
        },
        tooltip: config.dropdown.data[6].tipMsg,
    },
    {
        type: FormItemType.BUTTON,
        name: config.dropdown.data[7].id,
        options: {
            icon: <img src={TABLE_BOXICON_8_ICON} alt={''} style={{ margin: '-4px' }}/>,
        },
        tooltip: config.dropdown.data[7].tipMsg,
    },
    {
        type: FormItemType.BUTTON,
        name: config.dropdown.data[8].id,
        options: {
            icon: <img src={TABLE_BOXICON_9_ICON} alt={''} style={{ margin: '-4px' }}/>,
        },
        tooltip: config.dropdown.data[8].tipMsg,
    },
    {
        type: FormItemType.BUTTON,
        name: config.dropdown.data[9].id,
        options: {
            icon: <img src={TABLE_BOXICON_10_ICON} alt={''} style={{ margin: '-4px' }}/>,
        },
        tooltip: config.dropdown.data[9].tipMsg,
    },
];
